import React, { Component } from 'react';
import Icon from '../../../icons/Icon';
import DatePickerQuickSelectComponent from './DatePickerQuickSelectComponent';
import DatePickerDefaultSelectComponent from './DatePickerDefaultSelectComponent';
import { DatePickerSelectType, FormicaTimePickerDate } from './TimePickerDomain';
import moment from 'moment';
import MessageUtil from '../../../util/MessageUtil';
import { saveDatesToLocalStorage } from './TimePickerContainer';
import CustomLoading from '../CustomLoading';
import LanguageUtil from '../../../util/LanguageUtil';

class DateFilterComponent extends Component<Props, State> {
  public state = new State();

  render() {
    return (
      <div
        style={{ boxShadow: '0px 4px 6px -2px #00000008 0px 12px 16px -4px #00000014' }}
        className={'flex flex-col w-[730px] h-full gap-3 bg-white rounded-[8px] px-4 py-4'}
      >
        {!this.state.startDate || (!this.state.endDate && <CustomLoading />)}
        <div className={'flex gap-x-3'}>
          <div
            onClick={this.onClickQuickTimeFilter}
            className='cursor-pointer relative group border rounded border-[#E0E4E8] h-9 w-9 flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
          >
            <Icon icon={'calendar'} size={16} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
            <div
              className={
                'z-50 -bottom-5 rounded absolute hidden px-[10px] w-[120px] py-[5px] text-sm text-white bg-primary group-hover:flex group-hover:items-center group-hover:justify-center'
              }
            >
              Quick
              {LanguageUtil.get({ id: 'common.label.filter', defaultMessage: 'Filter' })}
            </div>
          </div>
          <div className={'flex items-center justify-between w-full bg-white border-[1px] border-[#E0E4E8] rounded-[4px] h-9 text-f-black-2 text-md'}>
            <div className={'flex w-full items-center justify-end'}>
              <p>{this.state.startDate?.label || 'From'}</p>
            </div>
            <div className={'flex items-center w-1/4 justify-center'}>
              <p>{'->'}</p>
            </div>
            <div className={'flex items-center justify-start w-full'}>
              <p>{this.state.endDate?.label || 'To'}</p>
            </div>
          </div>
        </div>
        {this.getDatePickerBySelectType()}
      </div>
    );
  }

  public componentDidMount() {
    const { startDate, endDate, selectType = 'DEFAULT' } = this.props;
    this.setStartDate(startDate);
    this.setEndDate(endDate);
    this.setState({ selectType });
  }

  private setStartDate = (startDate: FormicaTimePickerDate) => {
    this.setState({ startDate });
  };

  private setEndDate = (endDate: FormicaTimePickerDate) => {
    this.setState({ endDate });
  };

  private toTimestamp = (date: FormicaTimePickerDate): number => {
    if (date.type === 'Now' || date.value === 'Now' || date.value === 0) return Date.now();
    return moment(date.value).valueOf();
  };

  private onDatesApply = (startDate: FormicaTimePickerDate, endDate: FormicaTimePickerDate) => {
    const { onChangeStartDate, onChangeEndDate, onApply } = this.props;
    const startDateTimeStamp = this.toTimestamp(startDate);
    const endDateTimeStamp = this.toTimestamp(endDate);
    const selectedRound = (window as any)['CustomRelativeTimePicker_round_Start Date'] || (window as any)['CustomRelativeTimePicker_round_End Date'];

    if (endDateTimeStamp < startDateTimeStamp && endDateTimeStamp != 0 && startDateTimeStamp != 0 && !selectedRound) {
      MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'messages.confirm.endDate', defaultMessage: 'End date can not be less than start date.' }),
      });
      return;
    }

    this.setStartDate(startDate);
    this.setEndDate(endDate);
    onChangeStartDate(startDate);
    onChangeEndDate(endDate);
    onApply();
    saveDatesToLocalStorage(startDate, endDate);
  };

  private onClickQuickTimeFilter = () => {
    const { selectType } = this.state;
    if (selectType == 'QUICK') {
      this.setState({ selectType: 'DEFAULT' });
      return;
    }
    this.setState({ selectType: 'QUICK' });
  };

  private getDatePickerBySelectType = () => {
    const { selectType, startDate, endDate } = this.state;
    const { roundVisible } = this.props;
    if (!selectType || !startDate || !endDate) return;
    switch (selectType) {
      case 'QUICK':
        return (
          <DatePickerQuickSelectComponent
            setStartDate={this.setStartDate}
            startDate={startDate}
            setEndDate={this.setEndDate}
            endDate={endDate}
            onApply={this.onDatesApply}
          />
        );
      case 'DEFAULT':
        return (
          <DatePickerDefaultSelectComponent
            setStartDate={this.setStartDate}
            startDate={startDate}
            setEndDate={this.setEndDate}
            endDate={endDate}
            onApply={this.onDatesApply}
            roundVisible={roundVisible}
          />
        );
    }
  };
}

interface Props {
  onApply: VoidFunction;
  startDate: FormicaTimePickerDate;
  endDate: FormicaTimePickerDate;
  onChangeStartDate: (date: FormicaTimePickerDate) => void;
  onChangeEndDate: (date: FormicaTimePickerDate) => void;
  selectType: DatePickerSelectType;
  roundVisible?: boolean;
}

class State {
  selectType: DatePickerSelectType = 'DEFAULT';
  startDate: FormicaTimePickerDate | undefined = undefined;
  endDate: FormicaTimePickerDate | undefined = undefined;
}

export default DateFilterComponent;
